<div class="export-row-container">
  <div class="table-body-head">
    <div class="export-container">
      <tui-hosted-dropdown
        tuiDropdownLimitWidth="auto"
        [content]="download_options"
        [(open)]="open"
      >
        <button
          tuiHostedDropdownHost
          class="export-button"
          type="button"
          [disabled]="(isLoading$ | async) || paginatedData.length === 0"
        >
          <img
            src="assets/icons/download-Icon.svg"
            alt="download"
            class="img-icon"
          />
          {{ "historical_table.export_text" | translate }}
        </button>
      </tui-hosted-dropdown>
    </div>
  </div>
</div>

<!-- Filtros (Reactive Forms) -->
<form class="table-body-options" [formGroup]="filtersForm" novalidate>
  <!-- Buscador -->
  <div class="search-bar">
    <img
      src="assets/icons/search-icon.svg"
      alt="{{ 'historical_table.search_icon_alt' | translate }}"
      class="search-icon"
    />
    <input
      id="searchInput"
      class="search-bar-input"
      type="text"
      formControlName="search"
      [attr.aria-label]="'historical_table.search_text' | translate"
      placeholder="{{ 'historical_table.search_text' | translate }}"
    />
  </div>

  <!-- Rango de fechas -->
  <tui-input-date-range
    class="custom_select"
    formControlName="dateRange"
    tuiTextfieldSize="s"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldLabelOutside]="true"
  >
    {{ "historical_table.date_input" | translate }}
    <input
      tuiTextfield
      placeholder="{{ 'historical_table.date_range_placeholder' | translate }}"
    />
  </tui-input-date-range>

  <!-- Zona -->
  <ng-select
    class="custom_select"
    [items]="zones"
    bindLabel="zoneName"
    [bindValue]="useApiFiltering ? 'zoneId' : 'zoneName'"
    formControlName="zones"
    [multiple]="true"
    [loading]="isLoading"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'historical_table.zone_input' | translate }}"
  ></ng-select>

  <!-- Products -->

  <ng-select
    class="filter-item custom_select"
    formControlName="products"
    [bindLabel]="'ProductKey'"
    [bindValue]="'ProductName'"
    [loading]="isLoading || isLoadingProducts"
    [items]="products"
    [multiple]="true"
    [clearable]="true"
    placeholder="{{
      'service_manager.pending_service.products_input' | translate
    }}"
  ></ng-select>

  <!-- Estado -->
  <ng-select
    class="custom_select"
    [items]="orderStatus"
    bindLabel="statusName"
    bindValue="nodeStatus"
    formControlName="status"
    [loading]="isLoading"
    [clearable]="true"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'historical_table.status_input' | translate }}"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item.statusName | translate }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.statusName | translate }}
    </ng-template>
  </ng-select>

  <!-- Clientes -->
  <ng-select
    class="custom_select"
    [items]="allClients"
    bindLabel="clientName"
    [bindValue]="useApiFiltering ? 'clientId' : 'clientName'"
    formControlName="clients"
    [loading]="isLoading"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'historical_table.clients_input' | translate }}"
  ></ng-select>

  <!-- Conductores -->
  <ng-select
    class="custom_select"
    [items]="allDrivers"
    bindLabel="driverName"
    bindValue="driverName"
    formControlName="drivers"
    [loading]="isLoading"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'historical_table.drivers_input' | translate }}"
  ></ng-select>

  <!-- [ER - 14/08/2025] - Pending to have the getAllProducts from backend -->
  <!-- Productos -->
  <!-- <ng-select
    class="custom_select"
    [items]="products"
    bindLabel="product"
    bindValue="product"
    formControlName="product"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'historical_table.products_input' | translate }}"
  ></ng-select> -->
</form>

<!-- Tabla -->
<div class="table-wrapper">
  <table tuiTable size="l" [columns]="columns">
    <thead>
      <tr tuiThGroup>
        <th
          *tuiHead="'licensePlate'"
          tuiTh
          (click)="setSortColumn('licensePlate')"
          [sticky]="true"
        >
          {{ "historical_table.plate_input_table" | translate }}
        </th>
        <th
          *tuiHead="'time'"
          tuiTh
          (click)="setSortColumn('startHour')"
          [sticky]="true"
        >
          {{ "historical_table.hour_input_table" | translate }}
        </th>
        <th
          *tuiHead="'orderHash'"
          tuiTh
          (click)="setSortColumn('orderHash')"
          [sticky]="true"
        >
          {{ "historical_table.hash_input_table" | translate }}
        </th>
        <th
          *tuiHead="'zone'"
          tuiTh
          (click)="setSortColumn('zoneName')"
          [sticky]="true"
        >
          {{ "historical_table.zone_input_table" | translate }}
        </th>
        <th
          *tuiHead="'date'"
          tuiTh
          (click)="setSortColumn('assignedStartDate')"
        >
          {{ "historical_table.date_input_table" | translate }}
        </th>
        <th
          *tuiHead="'product'"
          tuiTh
          (click)="setSortColumn('productName')"
          [sticky]="true"
        >
          {{ "historical_table.product_input_table" | translate }}
        </th>
        <th
          *tuiHead="'status'"
          tuiTh
          (click)="setSortColumn('nodeStatus')"
          [sticky]="true"
        >
          {{ "historical_table.status_input_table" | translate }}
        </th>
        <th
          *tuiHead="'client'"
          tuiTh
          (click)="setSortColumn('clientName')"
          [sticky]="true"
        >
          {{ "historical_table.client_input_table" | translate }}
        </th>
        <th
          *tuiHead="'driver'"
          tuiTh
          (click)="setSortColumn('driverName')"
          [sticky]="true"
        >
          {{ "historical_table.column_driver" | translate }}
        </th>
        <th
          *tuiHead="'totalPrice'"
          tuiTh
          (click)="setSortColumn('totalPrice')"
          [sticky]="true"
        >
          {{ "historical_table.column_price" | translate }}
        </th>
        <th *tuiHead="'actions'" tuiTh [sorter]="null">
          {{ "historical_table.column_actions" | translate }}
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <ng-container *ngIf="!(isLoading$ | async) && paginatedData.length > 0">
        <tr tuiTr *ngFor="let item of paginatedData; trackBy: trackByOrderHash">
          <td *tuiCell="'licensePlate'" tuiTd>
            <span tuiTitle>{{ display(item.licensePlate) }}</span>
          </td>
          <td *tuiCell="'time'" tuiTd>
            <span
              tuiTitle
              [ngClass]="{
                'red-text': isWithin48Hours(
                  item.assignedStartDate,
                  item.driverName
                )
              }"
            >
              {{ formatHourRange(item.assignedStartDate, item.endDate) }}
            </span>
          </td>
          <td *tuiCell="'orderHash'" tuiTd>
            <span tuiTitle>{{ display(item.orderHash) }}</span>
          </td>
          <td *tuiCell="'zone'" tuiTd>
            <span tuiTitle>{{ display(item.zoneName) }}</span>
          </td>
          <td *tuiCell="'date'" tuiTd>
            <img
              *ngIf="isWithin48Hours(item.assignedStartDate, item.driverName)"
              src="assets/icons/alert-red-circle.svg"
              alt="{{ 'historical_table.alert_icon' | translate }}"
              class="alert-icon"
              [tuiHint]="
                formatDate(item.assignedStartDate) +
                ' · ' +
                formatHourRange(item.assignedStartDate, item.endDate) +
                (isWithin48Hours(item.assignedStartDate, item.driverName)
                  ? ' · ' + ('historical_table.tooltip_within_48h' | translate)
                  : '')
              "
              tuiHintDirection="top"
            />
            <span
              tuiTitle
              [tuiHint]="
                formatDate(item.assignedStartDate) +
                ' · ' +
                formatHourRange(item.assignedStartDate, item.endDate) +
                (isWithin48Hours(item.assignedStartDate, item.driverName)
                  ? ' · ' + ('historical_table.tooltip_within_48h' | translate)
                  : '')
              "
              tuiHintDirection="top"
              [ngClass]="{
                'red-text': isWithin48Hours(
                  item.assignedStartDate,
                  item.driverName
                )
              }"
            >
              {{ formatDate(item.assignedStartDate) }}
            </span>
          </td>
          <td *tuiCell="'product'" tuiTd>
            <span tuiTitle>
              {{
                item.productName
                  ? translateProduct(item.productName)
                  : ("historical_table.no_product" | translate)
              }}
            </span>
          </td>
          <td *tuiCell="'status'" tuiTd>
            <tui-badge
              *ngIf="item.nodeStatus !== null && item.nodeStatus !== undefined"
              [status]="getOrderStatusMeta(item.nodeStatus).tuiStatus"
              [value]="getOrderStatusMeta(item.nodeStatus).label | translate"
              [class]="getOrderStatusMeta(item.nodeStatus).cssClass"
            ></tui-badge>
          </td>
          <td *tuiCell="'client'" tuiTd>
            <span tuiTitle>{{ display(item.clientName) }}</span>
          </td>
          <td *tuiCell="'driver'" tuiTd>
            <span tuiTitle *ngIf="item.driverName?.trim(); else noDriver">
              {{ item.driverName }}
            </span>
            <ng-template #noDriver>
              <tui-tag
                class="tag"
                status="custom"
                [hoverable]="true"
                [value]="'historical_table.unassigned' | translate"
              ></tui-tag>
            </ng-template>
          </td>
          <td *tuiCell="'totalPrice'" tuiTd>
            <div [tuiCell]="size">
              <ng-container *ngIf="item?.totalPrice != null; else noPrice">
                <span tuiTitle tuiCell="l">
                  {{ item.totalPrice | number : "1.2-2" }}
                  {{ item.currencySymbol }}
                </span>
              </ng-container>

              <ng-template #noPrice>
                <span tuiTitle>–</span>
              </ng-template>
            </div>
          </td>
          <td *tuiCell="'actions'" tuiTd>
            <button
              class="seeAllIcon"
              appearance="link"
              icon="tuiIconEye"
              size="xs"
              tuiAppearance="link"
              tuiIconButton
              (click)="viewDetail(item)"
            >
              {{ "historical_table.column_actions" | translate }}
            </button>
          </td>
        </tr>
      </ng-container>

      <!-- Loader -->
      <tr *ngIf="isLoading$ | async">
        <td [attr.colspan]="columns.length" class="horizontal-text-center">
          <tui-loader size="l"></tui-loader>
        </td>
      </tr>

      <!-- Vacío -->
      <tr *ngIf="!(isLoading$ | async) && paginatedData.length === 0">
        <td [attr.colspan]="columns.length" class="empty-message">
          {{ "historical_table.empty_search" | translate }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Paginación -->
<div
  class="table-pagination"
  *ngIf="!(isLoading$ | async) && paginatedData.length > 0"
>
  <tui-pagination
    [index]="index"
    [length]="length"
    (indexChange)="goToPage($event)"
  ></tui-pagination>
</div>

<!-- ▒▒▒  TEMPLATE: Export opciones  ▒▒▒ -->
<ng-template #download_options>
  <div class="download-menu">
    <h3 class="export-title">
      {{ "historical_table.complement_export_text" | translate }}
    </h3>
    <div class="checkbox-container">
      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportXlsx"></tui-checkbox>
        <span class="export-body-label">
          {{ "historical_table.export_excel" | translate }}
        </span>
      </div>
      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportCsv"></tui-checkbox>
        <span class="export-body-label">
          {{ "historical_table.export_csv" | translate }}
        </span>
      </div>
    </div>
    <button
      type="button"
      class="export-button-menu"
      (click)="exportSelected()"
      [disabled]="!exportCsv && !exportXlsx"
    >
      <img src="assets/icons/download-Icon.svg" alt="" class="img-icon" />
      {{ "historical_table.export_text" | translate }}
    </button>
  </div>
</ng-template>
